import { ClsLog, ClsLogData } from "../../models/logging/clsLog";
import { RequestLog } from "../../models/logging/requestLog";
import { ResponseLog } from "../../models/logging/responseLog";

interface MiddlewareApplicationLog {
  requestId: string;
  request?: RequestLog;
  response?: ResponseLog;
  error?: string;
}

export const setClsMiddlewareApplicationLog = (clsBody: MiddlewareApplicationLog) => {
  const { requestId, request, response, error } = clsBody;
  const strRequest = request ? JSON.stringify(request) : undefined;
  const strResponse = response ? JSON.stringify(response) : undefined;
  return {
    requestId,
    body: { request: strRequest, response: strResponse, errors: error } as ClsLogData,
  } as ClsLog;
};
